import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h4>Company</h4>
            <p>Esme HC Ltd</p>
            <p>Company Number: 16987832</p>
          </div>

          <div className="footer-section">
            <h4>Contact</h4>
            <p>
              <a href="mailto:hello@esmehc.com">hello@esmehc.com</a>
            </p>
          </div>

          <div className="footer-section">
            <h4>Address</h4>
            <p>28 City Road, London EC1V 2NX</p>
          </div>

          <div className="footer-section">
            <h4>Sections</h4>
            <ul>
              <li><a href="#about">About</a></li>
              <li><a href="#services">Services</a></li>
              <li><a href="#contact">Contact</a></li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Esmé Hospitality Collective. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
